import React from 'react';
import './App.css';
import MainComponent from './components/mainComponent';
import { Routes, Route } from 'react-router-dom';
import { ProductType } from './constants/types';
import Marktplaats from './components/marktplaatsComponent';

const App: React.FunctionComponent = () => {
  return (
    <div>
      <Main />
    </div>
  );
};

const Main = () => (
  <Routes>
    <Route path="*" element={<MainComponent />} />
  </Routes>
);

export default App;
